module.exports = __webpack_public_path__ + "static/assets/3714d94dcb0a446129bc03d427731b5d.gif";